function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);


  if (elementToFocus) {
    elementToFocus.focus();
  }

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function applyMerchantWidgetIframeTitle() {
  const merchantWidgetIframe = document.getElementById('merchantwidgetiframe');
  if (!merchantWidgetIframe || merchantWidgetIframe.hasAttribute('title')) return false;

  merchantWidgetIframe.setAttribute('title', 'Google Merchant Center widget');
  return true;
}

(function initMerchantWidgetIframeAccessibility() {
  const startObserver = () => {
    if (applyMerchantWidgetIframeTitle()) return;

    if (typeof MutationObserver === 'undefined' || !document.body) return;

    const merchantWidgetObserver = new MutationObserver(() => {
      if (applyMerchantWidgetIframeTitle()) {
        merchantWidgetObserver.disconnect();
      }
    });

    merchantWidgetObserver.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(() => {
      merchantWidgetObserver.disconnect();
    }, 6000);
  };

  const scheduleObserver = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startObserver, { timeout: 2500 });
    } else {
      window.setTimeout(startObserver, 1200);
    }
  };

  if (document.readyState === 'complete') {
    scheduleObserver();
    return;
  }

  window.addEventListener('load', scheduleObserver, { once: true });
})();

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video:not([data-ignore-pause])').forEach((video) => {
    video.pause();
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};



class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 150);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    detailsElement.classList.add('is-closing');
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        
        detailsElement.removeAttribute('open');
        detailsElement.classList.remove('is-closing'); 
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    this.mainDetailsToggle.classList.add('is-opening');

    requestAnimationFrame(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.classList.add('menu-opening');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('is-opening');
      }, 300); 
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);



class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.addEventListener('keydown', this.handleKeyDown);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.hasAttribute('open')) {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
  
    // Trap focus within the modal dialog
    setTimeout(() => {
      const firstFocusableElement = this.querySelector('a, input, button, [tabindex]:not([tabindex="-1"])');
      trapFocus(this, firstFocusableElement);
    },300);
    
  }
  

  hide() {
    this.setAttribute("closing", "true"),
    setTimeout(() => {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    this.removeAttribute("closing");
    removeTrapFocus(this.openedBy);
    },300);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    this.button = button;
    this.sizeGuideUrl = this.dataset.sizeGuideUrl;

    button.addEventListener('click', () => {
      if (this.sizeGuideUrl) {
        this.openSizeGuide();
        return;
      }

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });

    if (!this.sizeGuideUrl) return;

    if (
      new URLSearchParams(window.location.search).get('size_chart') === 'open' &&
      this.closest('product-info') &&
      !window.mymaraSizeGuideAutoOpened
    ) {
      window.mymaraSizeGuideAutoOpened = true;
      this.openSizeGuide();
    }

    button.addEventListener('pointerenter', this.warmSizeGuide.bind(this), { once: true });
    button.addEventListener('focusin', this.warmSizeGuide.bind(this), { once: true });

    if (typeof IntersectionObserver === 'function') {
      this.sizeGuideObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.warmSizeGuide();
          this.sizeGuideObserver.disconnect();
        }
      }, { rootMargin: '300px 0px' });
      this.sizeGuideObserver.observe(this);
    }
  }

  warmSizeGuide() {
    this.loadSizeGuide().catch(() => {});
  }

  loadSizeGuide() {
    if (this.sizeGuidePromise) return this.sizeGuidePromise;

    this.button.setAttribute('aria-busy', 'true');
    this.sizeGuidePromise = fetch(this.sizeGuideUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Size guide request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const responseDocument = new DOMParser().parseFromString(html, 'text/html');
        const modal = responseDocument.querySelector('modal-dialog.mymara-size-guide-modal');

        if (!modal) throw new Error('Size guide modal was not found in the response');

        const sizeGuide = modal.querySelector('mymara-size-guide');
        if (sizeGuide && this.dataset.sizeGuideSectionId) {
          sizeGuide.dataset.sectionId = this.dataset.sizeGuideSectionId;
        }
        modal.id = this.getAttribute('data-modal').slice(1);

        responseDocument.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
          if (!document.head.querySelector(`link[href*="${link.href.split('/').pop().split('?')[0]}"]`)) {
            document.head.appendChild(link.cloneNode(true));
          }
        });

        document.body.appendChild(modal);
        return modal;
      })
      .catch((error) => {
        this.sizeGuidePromise = null;
        throw error;
      })
      .finally(() => {
        this.button.removeAttribute('aria-busy');
      });

    return this.sizeGuidePromise;
  }

  openSizeGuide() {
    this.loadSizeGuide()
      .then((modal) => modal.show(this.button))
      .catch((error) => console.error('Failed to load size guide:', error));
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) {
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  }
};
setScrollbarWidth();
window.addEventListener("resize", throttle(setScrollbarWidth));

class ResponsiveImage extends HTMLElement {
  static getResizeObserver() {
    if (!this.sharedResizeObserver && 'ResizeObserver' in window) {
      this.sharedResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => entry.target.updateSizes(entry.contentRect.width));
      });
    }
    return this.sharedResizeObserver;
  }

  static getIntersectionObserver() {
    if (!this.sharedIntersectionObserver && 'IntersectionObserver' in window) {
      this.sharedIntersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.activateSizing(entry.boundingClientRect.width);
          this.sharedIntersectionObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0 });
    }
    return this.sharedIntersectionObserver;
  }

  constructor() {
    super();
    this.onImageLoad = this.onImageLoad.bind(this);
    this.activateSizing = this.activateSizing.bind(this);
    this.updateSizes = this.updateSizes.bind(this);
  }

  connectedCallback() {
    this.img = this.querySelector('img');
    if (!this.img) {
      return;
    }

    this.img.addEventListener('load', this.onImageLoad);

    if (this.img.complete && this.img.naturalWidth > 0) {
      this.onImageLoad();
    } else {
      this.img.classList.add('img-loading');
    }

    if (this.dataset.sizes === 'true') {
      this.resizeObserver = ResponsiveImage.getResizeObserver();
      this.intersectionObserver = ResponsiveImage.getIntersectionObserver();
      if (this.shouldSizeImmediately()) {
        this.activateSizing();
      } else if (this.intersectionObserver) {
        this.intersectionObserver.observe(this);
      } else {
        this.activateSizing();
      }
    }
  }

  disconnectedCallback() {
    if (this.img) {
      this.img.removeEventListener('load', this.onImageLoad);
    }

    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this);
    }

    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this);
    }
  }

  onImageLoad() {
    this.img.classList.remove('img-loading');
    this.img.classList.add('img-loaded');
  }

  shouldSizeImmediately() {
    return this.img.loading === 'eager' || this.img.getAttribute('fetchpriority') === 'high';
  }

  activateSizing(width = null) {
    if (this.dataset.sizes !== 'true') {
      return;
    }

    this.updateSizes(width);

    if (this.resizeObserver) {
      this.resizeObserver.observe(this);
    }
  }

  updateSizes(width = null) {
    if (!this.img) {
      return;
    }

    const resolvedWidth = Math.ceil(width || this.clientWidth || this.img.clientWidth);

    if (resolvedWidth <= 0) {
      return;
    }

    const sizes = `${resolvedWidth}px`;

    if (this.img.getAttribute('sizes') !== sizes) {
      this.img.setAttribute('sizes', sizes);
    }
  }
}

customElements.define('responsive-image', ResponsiveImage);

class DailyDealBadge extends HTMLElement {
  connectedCallback() {
    if (this.classList.contains('daily-deal-badge--animate') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (!DailyDealBadge.observer) {
      DailyDealBadge.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          if (!isIntersecting || intersectionRatio < 0.35) return;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            target.classList.add('daily-deal-badge--animate');
          }
          DailyDealBadge.observer.unobserve(target);
        });
      }, { threshold: 0.35 });
    }
    DailyDealBadge.observer.observe(this);
  }

  disconnectedCallback() {
    DailyDealBadge.observer?.unobserve(this);
  }
}

customElements.define('daily-deal-badge', DailyDealBadge);

const loadCardSecondaryImage = (media) => {
  const template = media.querySelector('template[data-card-secondary-image]');
  if (!template) return;

  template.replaceWith(template.content.cloneNode(true));
};

const warmCardSecondaryImage = (event) => {
  const card = event.target.closest?.('.card-product--option-14');
  const media = card?.querySelector('.card-product__media-inner')
    || event.target.closest?.('.card-product__media-inner');
  if (!media) return;

  const relatedTarget = event.relatedTarget;
  if (relatedTarget instanceof Node && media.contains(relatedTarget)) return;

  loadCardSecondaryImage(media);
};

document.addEventListener('pointerover', warmCardSecondaryImage, { passive: true });
document.addEventListener('focusin', warmCardSecondaryImage);

// Pause product grid hover scripts (secondary image, swatch previews, card controls) while scrolling,
// since cards passing under a still cursor would otherwise run them all. Clicks are left alone.
(() => {
  let scrollEndTimeout = null;

  const suppressGridHover = (event) => {
    if (scrollEndTimeout && event.target.closest?.('#product-grid')) event.stopImmediatePropagation();
  };

  window.addEventListener('pointerover', suppressGridHover, true);
  window.addEventListener('mouseover', suppressGridHover, true);

  window.addEventListener('scroll', () => {
    if (!scrollEndTimeout && !document.getElementById('product-grid')) return;

    clearTimeout(scrollEndTimeout);
    scrollEndTimeout = setTimeout(() => {
      scrollEndTimeout = null;
    }, 150);
  }, { passive: true });
})();


/**
 *  @class
 *  @function ViewportMedia
 */

if (!customElements.get('viewport-media')) {
  class ViewportMedia extends HTMLElement {
    constructor() {
      super();
      this.initObserver();
    }
  
    initObserver() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadContent();
              this.observer.unobserve(entry.target);
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px 0px 200px 0px' 
        });
  
        this.observer.observe(this);
      } else {
        this.loadContent();
      }
    }
  
    loadContent() {
      if (!this.getAttribute('loaded')) {
        const template = this.querySelector('template');
        if (template && template.content && template.content.firstElementChild) {
          const content = document.createElement('div');
          content.appendChild(template.content.firstElementChild.cloneNode(true));
    
          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, iframe'));
    
          if (deferredElement.nodeName === 'IFRAME') {
            const src = deferredElement.getAttribute('data-src');
            if (src) {
              deferredElement.setAttribute('src', src);
            }
            deferredElement.onload = () => this.removePlaceholder();
          }
          if (deferredElement.nodeName === 'VIDEO') {
            const isAutoplay = deferredElement.getAttribute('autoplay');
            const poster = deferredElement.getAttribute('poster');
            if (!isAutoplay && poster) {
              deferredElement.setAttribute('poster', poster);
            }
            deferredElement.onloadeddata = () => {
             
              this.removePlaceholder();
              if (isAutoplay) {
                deferredElement.muted = true; 
                deferredElement.play().catch(error => {
                  console.warn('Autoplay failed:', error);
                });
              }
              this.initVideoControls(deferredElement);
            };
            deferredElement.load();
          }
        }
      }
    }


    initVideoControls(video) {
      const playPauseButton = this.querySelector('.video-play-pause');
      const muteToggleButton = this.querySelector('.video-mute-toggle');
      const progressFilled = this.querySelector('.video-progress-filled');
      let updateProgress;
    
      // Handle Play/Pause Button
      if (playPauseButton) {
        playPauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playPauseButton.classList.remove('is-play');
            playPauseButton.classList.add('is-pause');
            updateProgress = requestAnimationFrame(updateProgressBar);
          } else {
            video.pause();
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
            cancelAnimationFrame(updateProgress);
          }
        });
    
        // Reset button state on video end
        video.addEventListener('ended', () => {
          if (playPauseButton) {
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
          }
        });
      }
    
      // Handle Mute/Unmute Button
      if (muteToggleButton) {
        muteToggleButton.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.muted) {
            muteToggleButton.classList.add('is-muted');
            muteToggleButton.classList.remove('is-unmuted');
          } else {
            muteToggleButton.classList.remove('is-muted');
            muteToggleButton.classList.add('is-unmuted');
          }
        });
      }
    
      // Handle Progress Bar
      if (progressFilled) {
        const updateProgressBar = () => {
          const percentage = (video.currentTime / video.duration) * 100 || 0;
          progressFilled.style.width = `${percentage}%`;
    
          // Continue updating while playing
          updateProgress = requestAnimationFrame(updateProgressBar);
        };
    
        video.addEventListener('timeupdate', updateProgressBar);
    
        // Reset progress on end
        video.addEventListener('ended', () => {
          cancelAnimationFrame(updateProgress);
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
        });
    
        // Start progress tracking when the video can play
        video.addEventListener('canplay', () => {
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
          if (!video.paused) updateProgress = requestAnimationFrame(updateProgressBar);
        });
      }
    }
    
    
    removePlaceholder() {
      const placeholder = this.querySelector('.video-placeholder');
      if (placeholder) {
        placeholder.style.display = 'none';
      }
    }
  }
  
  customElements.define('viewport-media', ViewportMedia);
}


/**
 *  @class
 *  @function SplideCarousel
 */

  const SPLIDE_LAZY_MOUNT_OFFSET = 300;
  const SPLIDE_LAZY_MOUNT_ROOT_MARGIN = `${SPLIDE_LAZY_MOUNT_OFFSET}px 0px ${SPLIDE_LAZY_MOUNT_OFFSET}px 0px`;

  function canLazyMountSplide() {
    return 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode);
  }

  function shouldMountSplideImmediately(element) {
    if (!canLazyMountSplide()) return true;

    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const hasLayoutBox = rect.width > 0 || rect.height > 0;

    if (!hasLayoutBox) return false;

    return rect.top <= viewportHeight + SPLIDE_LAZY_MOUNT_OFFSET && rect.bottom >= -SPLIDE_LAZY_MOUNT_OFFSET;
  }

  function observeSplideMount(element, callback) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.disconnect();
        callback();
      });
    }, {
      rootMargin: SPLIDE_LAZY_MOUNT_ROOT_MARGIN
    });

    observer.observe(element);
    return observer;
  }

  class SplideCarousel extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.isUserInteracting = false; // Track if user is interacting
      this.mountObserver = null;
      this.observer = null;
      this.videoTimer = null;
      this.progressTimer = null;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
    }

    connectedCallback() {
      this.mountSplideWhenNeeded();

      if (Shopify.designMode) {
        this.addShopifyEventListeners();
      }
    }

    disconnectedCallback() {
      if (Shopify.designMode) {
        this.removeShopifyEventListeners();
      }

      if (this.mountObserver) {
        this.mountObserver.disconnect();
        this.mountObserver = null;
      }

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      clearTimeout(this.videoTimer);
      clearTimeout(this.progressTimer);
      this.slideInstance?.destroy();
      this.slideInstance = null;
    }

    mountSplideWhenNeeded() {
      if (this.slideInstance) return;

      if (shouldMountSplideImmediately(this)) {
        this.mountSplide();
        return;
      }

      if (this.mountObserver) return;

      this.mountObserver = observeSplideMount(this, () => {
        this.mountObserver = null;
        this.mountSplide();
      });
    }

    mountSplide() {
      if (this.slideInstance) return;

      const splideElement = this.querySelector('.splide');

      if (!splideElement) return;

      const options = splideElement.getAttribute('data-splide');

      if (options) {
        try {
          const parsedOptions = JSON.parse(options);
          this.slideInstance = new Splide(splideElement, parsedOptions);

          this.slideInstance.on('mounted', () => {
            this.handleVideoPlayback();
          });
          this.slideInstance.on('move', () => {
            this.handleVideoPlayback();
          });
          this.videoTimer = setTimeout(() => { if (this.isConnected) this.handleVideoPlayback(); }, 100);

          this.progressTimer = setTimeout(() => { if (this.isConnected) this.initializeProgressBar(); }, 300);
          this.slideInstance.mount();
        } catch (e) {
          console.error('Failed to initialize Splide carousel:', e);
        }
      }

      this.initObserver();
    }

    initObserver() {
      if (this.observer) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.handleVideoPlayback();
            }
          });
        }, {
          rootMargin: '0px 0px -50% 0px' 
        });
        
        this.observer.observe(this);
      } else {
        this.handleVideoPlayback();
      }
    }

    handleVideoPlayback() {
      if (!this.slideInstance) return;
    
      if (this.hasAttribute('data-play-videos') && this.getAttribute('data-play-videos') === 'true') {
        return;
      }
      const slides = this.slideInstance.Components.Elements.slides;
    
      slides.forEach((slide, index) => {
        const video = slide.querySelector('.shopable-video__video');
    
        if (video && !slide.classList.contains('is-clone')) {
          const isActiveSlide = this.slideInstance.index === index;
    
          if (isActiveSlide) {
            if (video.paused) {
              video.play().catch((e) => {
                console.error('Error playing video:', e);
              });
            }
          } else {
            if (!video.paused) {
              video.pause();
            }
          }
        } else if (video) {
          video.pause();
        }
      });
    }

    addShopifyEventListeners() {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    removeShopifyEventListeners() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    handleBlockSelect(event) {
      const blockElement = event.target;
      const carouselElement = blockElement.closest('splide-carousel');
      if (carouselElement === this && this.slideInstance) {
        const index = parseInt(blockElement.getAttribute('data-splide-index'));
        if (!isNaN(index)) {
          this.slideInstance.go(index);
          this.isUserInteracting = true;
          this.slideInstance.Components.Autoplay.pause();
        }
      }
    }

    handleBlockDeselect(event) {
      const blockElement = event.target;
      const carouselElement = blockElement.closest('splide-carousel');
      if (carouselElement === this && this.slideInstance) {
        this.isUserInteracting = false;
      }
    }

    initializeProgressBar() {
      const bar = this.querySelector('.splide-carousel-progress-bar');
      if (bar && this.slideInstance) {
        const updateProgressBar = () => {
          requestAnimationFrame(() => {
            const end = this.slideInstance.Components.Controller.getEnd() + 1;
            const rate = Math.min((this.slideInstance.index + 1) / end, 1);
            bar.style.width = `${100 * rate}%`;
          });
        };

        updateProgressBar();
        this.slideInstance.on('mounted move', updateProgressBar);

        this.slideInstance.on('destroy', () => {
          this.slideInstance.off('mounted move', updateProgressBar);
        });
      }
    }
  }
  customElements.define('splide-carousel', SplideCarousel);


/**
 *  @class
 *  @function Slideshow
 */
if (!customElements.get('slide-show')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.videoStates = new Map();
      this.mountObserver = null;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.loadDeferredSlideImages = this.loadDeferredSlideImages.bind(this);
    }

    connectedCallback() {
      this.scheduleDeferredSlideImages();
      this.mountSplideWhenNeeded();
      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }
    }

    disconnectedCallback() {
      if (Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      if (this.mountObserver) {
        this.mountObserver.disconnect();
        this.mountObserver = null;
      }
      this.slideInstance?.destroy();
      this.slideInstance = null;
    }

    mountSplideWhenNeeded() {
      if (this.slideInstance) return;

      if (shouldMountSplideImmediately(this)) {
        this.init();
        return;
      }

      if (this.mountObserver) return;

      this.mountObserver = observeSplideMount(this, () => {
        this.mountObserver = null;
        this.init();
      });
    }

    init() {
      if (this.slideInstance) return;

      const options = this.getAttribute('data-splide');
      if (options) {
        const parsedOptions = JSON.parse(options);
        this.slideInstance = new Splide(this, parsedOptions);

        if (this.getAttribute('data-pagination') === 'numbers') {
          this.slideInstance.on('pagination:mounted', this.customizePagination);
        }

        this.slideInstance.mount();
        this.slideInstance.on('move', this.loadDeferredSlideImages);
        this.slideInstance.on('moved', this.handleVideoPlayback.bind(this));
        this.slideInstance.on('moved', this.updateSlideCounter.bind(this));
        this.slideInstance.on('moved', this.handleFirstSlide.bind(this)); 
        this.updateSlideCounter(this.slideInstance.index);

        
      }
    }

    // Slides after the first wait until the first slide's image has loaded so they don't share bandwidth with it (LCP image).
    // Window load is the fallback for a first slide without an image
    scheduleDeferredSlideImages() {
      if (!this.querySelector('.slideshow-item__background [data-srcset]')) return;

      const loadWhenIdle = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(this.loadDeferredSlideImages, { timeout: 1500 });
          return;
        }

        window.setTimeout(this.loadDeferredSlideImages, 200);
      };

      const firstSlideImage = this.querySelector('.first-slide .slideshow-item__background img');
      if (document.readyState === 'complete' || firstSlideImage?.complete) {
        loadWhenIdle();
        return;
      }

      firstSlideImage?.addEventListener('load', loadWhenIdle, { once: true });
      firstSlideImage?.addEventListener('error', loadWhenIdle, { once: true });
      window.addEventListener('load', loadWhenIdle, { once: true });
    }

    // Also runs on Splide 'move', so a slide the visitor navigates to early still gets its image
    loadDeferredSlideImages() {
      this.querySelectorAll('.slideshow-item__background [data-srcset]').forEach((element) => {
        element.setAttribute('srcset', element.dataset.srcset);
        element.removeAttribute('data-srcset');

        if (element.dataset.src) {
          element.setAttribute('src', element.dataset.src);
          element.removeAttribute('data-src');
        }
      });
    }

    handleFirstSlide() {
      const slides = this.slideInstance.Components.Elements.slides;
      slides.forEach((slide) => {
        slide.classList.remove('first-slide');
      });
    }

    handleVideoPlayback() {
      const slides = this.slideInstance.Components.Elements.slides;
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          if (slide.classList.contains('is-active')) {
            video.play();
          } else {
            video.pause();
          }
        }
      });
    }

    updateSlideCounter(newIndex) {
      const totalSlides = this.slideInstance.length;
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement && totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
        currentSlideElement.textContent = newIndex + 1;
      }
    }

    customizePagination(data) {
      data.list.classList.add('splide__pagination--custom');
      data.items.forEach((item) => {
        item.button.textContent = String(item.page + 1).padStart(2, '0');
      });
    }

    handleBlockSelect(event) {
      const blockElement = event.target;
      const carouselElement = blockElement.closest('slide-show');
      if (carouselElement && carouselElement.slideInstance) {
        const index = parseInt(blockElement.getAttribute('data-splide-index'));
        if (!isNaN(index)) {
          carouselElement.slideInstance.go(index);
          carouselElement.isUserInteracting = true;
          carouselElement.slideInstance.Components.Autoplay.pause();
        }
      }
    }

    handleBlockDeselect(event) {
      const blockElement = event.target;
      const carouselElement = blockElement.closest('slide-show');
      if (carouselElement && carouselElement.slideInstance) {
        carouselElement.isUserInteracting = false;
      }
    }
  }

  customElements.define('slide-show', Slideshow);
}

/**
 *  @class
 *  @function AsyncCarousel
 */

if (!customElements.get('async-carousel')) {
  class AsyncCarousel extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.thumbnailInstance = null;
      this.isUserInteracting = false;
      this.thumbnails = null;
      this.currentThumbnail = null;
      this.progressTimer = null;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    }

    connectedCallback() {
      this.initCarousel();
    }

    initCarousel() {
      if (this.slideInstance) return;
      const mainSlider = this.querySelector('[data-slider="main"]');
      const thumbnailSlider = this.querySelector('[data-slider="thumbnail"]');

      if (mainSlider) {
        const mainOptions = JSON.parse(mainSlider.getAttribute('data-splide') || '{}');
        this.slideInstance = new Splide(mainSlider, mainOptions);
        
        if (thumbnailSlider) {
          const thumbnailOptions = JSON.parse(thumbnailSlider.getAttribute('data-splide') || '{}');
          this.thumbnailInstance = new Splide(thumbnailSlider, thumbnailOptions);
          this.slideInstance.sync(this.thumbnailInstance);
          this.updateThumbnailARIA(thumbnailSlider);
        }

        this.slideInstance.mount();
        if (this.thumbnailInstance) {
          this.thumbnailInstance.mount();
        }
        
        this.progressTimer = setTimeout(() => { if (this.isConnected) this.initializeProgressBar(); }, 300);
        this.initThumbnails();
        this.addShopifyEventListeners();
      }
    }

    disconnectedCallback() {
      if (Shopify.designMode) {
        this.removeShopifyEventListeners();
      }
      clearTimeout(this.progressTimer);
      this.removeEventListener('click', this.handleThumbnailClick);
      this.slideInstance?.destroy();
      this.thumbnailInstance?.destroy();
      this.slideInstance = null;
      this.thumbnailInstance = null;
      this.currentThumbnail = null;
    }

    addShopifyEventListeners() {
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }
    }

    removeShopifyEventListeners() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    handleBlockSelect(event) {
      const blockElement = event.target;
      const index = parseInt(blockElement.getAttribute('data-splide-index'));

      if (!isNaN(index) && this.slideInstance) {
        this.slideInstance.go(index);
        this.isUserInteracting = true;
        this.slideInstance.Components.Autoplay.pause();
      }
    }

    handleBlockDeselect() {
      this.isUserInteracting = false;
    }

    initThumbnails() {
      this.thumbnails = this.querySelectorAll('.thumbnail-item');
      this.addEventListener('click', this.handleThumbnailClick);

      this.slideInstance.on('mounted move', () => {
        const thumbnail = this.thumbnails[this.slideInstance.index];
        if (thumbnail) {
          if (this.currentThumbnail) {
            this.currentThumbnail.classList.remove('is-active');
          }
          thumbnail.classList.add('is-active');
          this.currentThumbnail = thumbnail;
        }
      });
    }

    handleThumbnailClick(event) {
      const thumbnail = event.target.closest('.thumbnail-item');
      if (!thumbnail || !this.contains(thumbnail) || !this.slideInstance) return;
      const index = [...this.thumbnails].indexOf(thumbnail);
      if (index >= 0) this.slideInstance.go(index);
    }

    initializeProgressBar() {
      const bar = this.querySelector('.splide-carousel-progress-bar');
      if (bar && this.slideInstance) {
        const updateProgressBar = () => {
          const end = this.slideInstance.Components.Controller.getEnd() + 1;
          const rate = Math.min((this.slideInstance.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        };

        updateProgressBar();
        this.slideInstance.on('mounted move', updateProgressBar);
      }
    }

    updateThumbnailARIA(thumbnailSlider) {
      const thumbnailItems = thumbnailSlider.querySelectorAll('.splide__slide');
      thumbnailItems.forEach(thumbnailItem => {
        thumbnailItem.setAttribute('role', 'group');
      });
    }
  }

  customElements.define('async-carousel', AsyncCarousel);
}


/**
 *  @class
 *  @function GalleryCarousel
 */

if (!customElements.get('gallery-carousel')) {
  class GalleryCarousel extends HTMLElement {
    constructor() {
      super();
      this.main = null;
      this.thumbnails = null;
      this.originalSlides = [];
      this.originalThumbnails = [];
      this.mediaGroups = new Map();
      this.activeMediaGroup = null;
      this.hasInitialized = false;
      this.mountTimer = null;
      this.initializeCarouselsWhenReady = this.initializeCarouselsWhenReady.bind(this);
      this.onColorChange = this.onColorChange.bind(this);
    }

    connectedCallback() {
      this.mainCarousel = this.querySelector('[id^="Main-Carousel"]');
      this.thumbnailCarousel = this.querySelector('[id^="Thumbnail-Carousel"]');

      if (!this.mainCarousel || !this.thumbnailCarousel) {
        console.error('Main or thumbnail carousel element not found.');
        return;
      }

      this.originalSlides = [...this.mainCarousel.querySelectorAll('.splide__slide')];
      this.originalThumbnails = [...this.thumbnailCarousel.querySelectorAll('.splide__slide')];
      this.mediaGroups.clear();
      for (const slide of this.originalSlides) {
        const group = slide.dataset.mediaGroup;
        if (!group) continue;
        const entry = this.mediaGroups.get(group) || { slides: [], thumbnails: [] };
        entry.slides.push(slide);
        this.mediaGroups.set(group, entry);
      }
      for (const thumbnail of this.originalThumbnails) {
        const entry = this.mediaGroups.get(thumbnail.dataset.mediaGroup);
        if (entry) entry.thumbnails.push(thumbnail);
      }
      this.scheduleInitialization();
    }

    disconnectedCallback() {
      this.productSection?.removeEventListener('change', this.onColorChange);
      this.productSection = null;
      clearTimeout(this.mountTimer);
      this.main?.destroy();
      this.thumbnails?.destroy();
      this.mainCarousel?.querySelector('.splide__list')?.replaceChildren(...this.originalSlides);
      this.thumbnailCarousel?.querySelector('.splide__list')?.replaceChildren(...this.originalThumbnails);
      this.main = null;
      this.thumbnails = null;
      this.hasInitialized = false;
      this.activeMediaGroup = null;
    }

    onColorChange(event) {
      if (event.target.matches(".variant-picker__color input[type='radio']")) {
        this.filterSlides(event.target.value);
      }
    }

    scheduleInitialization() {
      if (this.hasInitialized) return;

      const scheduleMount = () => {
        if (this.hasInitialized || !this.isConnected) return;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => { if (this.isConnected) this.initializeCarouselsWhenReady(); });
        });
      };

      const selectedHeroImage = this.querySelector('.splide__slide[data-selected="true"] img');

      if (selectedHeroImage && !selectedHeroImage.complete) {
        selectedHeroImage.addEventListener('load', scheduleMount, { once: true });
        this.mountTimer = window.setTimeout(scheduleMount, 1800);
        return;
      }

      scheduleMount();
    }

    initializeCarouselsWhenReady() {
      if (this.hasInitialized || !this.isConnected) return;

      const mainOptions = this.getCarouselOptions(this.mainCarousel);
      const thumbnailOptions = this.getCarouselOptions(this.thumbnailCarousel);

      const initialSlideIndex = this.getInitialSlideIndex();

      mainOptions.start = initialSlideIndex;
      thumbnailOptions.start = initialSlideIndex;

      this.initializeCarousels(this.mainCarousel, mainOptions, this.thumbnailCarousel, thumbnailOptions);
      this.addEventListeners();
      this.hasInitialized = true;

      const enableFiltering = this.dataset.mediaGrouping === "true";
      if (enableFiltering) {
        const defaultFilter = this.dataset.filterSelected;
        this.filterSlides(defaultFilter);

        this.productSection = this.closest('.product') || this.closest('section') || this.parentElement;
        this.productSection.addEventListener('change', this.onColorChange);
      }
    }

    getCarouselOptions(carouselElement) {
      return JSON.parse(carouselElement.getAttribute('data-splide') || '{}');
    }

    getInitialSlideIndex() {
      const selectedThumbnailSlide = this.querySelector('.thumbnail-carousel .splide__slide[data-selected="true"]');
      
      if (selectedThumbnailSlide) {
        const thumbnailSlides = Array.from(this.querySelectorAll('.thumbnail-carousel .splide__slide'));
        return thumbnailSlides.indexOf(selectedThumbnailSlide);
      }
      return 0;
    }

    initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions) {
      this.main = new Splide(mainCarousel, mainOptions);
      this.thumbnails = new Splide(thumbnailCarousel, thumbnailOptions);
      const isVerticalThumbnail = thumbnailCarousel.getAttribute('data-thumbnail') === 'vertical';
      if (isVerticalThumbnail) {
        this.thumbnails.on('mounted', () => {
          const thumbnailList = thumbnailCarousel.querySelector('.splide__list');
          if (thumbnailList) {
            thumbnailList.setAttribute('role', 'tablist');
          }
        });
        this.thumbnails.on('mounted', this.updateThumbnailARIA.bind(this));
      }

      this.main.on('mounted', () => {
        mainCarousel.classList.remove('is-initializing');
        if (this.main.index !== undefined) {
            this.updateSlideCounter(this.main.index);
        }
      });

      this.thumbnails.mount();
      this.main.sync(this.thumbnails);
      this.main.mount();
      this.main.on('moved', this.updateSlideCounter.bind(this));
      this.updateSlideCounter(this.main.index);
      
    }

    addEventListeners() {
      this.main.on('inactive', this.handleInactiveSlide.bind(this));
      this.main.on('active', this.handleMainActiveSlide.bind(this));
      this.thumbnails.on('active', this.handleThumbnailActiveSlide.bind(this));
    }

    updateSlideCounter(newIndex) {
      const totalSlides = this.main.length;
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement && totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
        currentSlideElement.textContent = newIndex + 1;
      }
    }

    handleInactiveSlide(oldSlide) {
      const inactiveSlide = this.main.Components.Elements.slides[oldSlide.index];
      this.pauseYouTubeVideo(inactiveSlide);
    }

    handleMainActiveSlide(newSlide) {
      window.pauseAllMedia();
      const activeSlide = this.main.Components.Elements.slides[newSlide.index];
      this.handleActiveSlide(activeSlide);

      const hasProductModel = activeSlide.querySelector('product-model') !== null;
      this.main.Components.Drag.disable(hasProductModel);
    }

    handleThumbnailActiveSlide(newSlide) {
      window.pauseAllMedia();
      const target = this.thumbnails.Components.Elements.slides[newSlide.index].getAttribute('data-target');
      const activeSlide = Array.from(this.main.Components.Elements.slides).find(slide => slide.getAttribute('data-media-id') === target);
      this.handleActiveSlide(activeSlide);
    }

    handleActiveSlide(slide) {
      if (slide && !slide.dataset.played) {
        const autoplay = this.getAttribute('data-autoplay');
        if (autoplay === 'true') {
          this.playActiveMedia(slide);
          slide.dataset.played = true;
        }
      }
    }

    playActiveMedia(activeSlide) {
      const deferredMedia = activeSlide.querySelector('.deferred-media');
      if (deferredMedia) {
        
        deferredMedia.loadContent(false);
      }
    }

    pauseYouTubeVideo(slide) {
      const iframe = slide.querySelector('iframe');
      if (iframe && iframe.src.includes('youtube.com')) {
        iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
      }
    }

    updateCarouselImages(mediaId) {
      if (!this.main) {
        return;
      }
      const mainSlides = this.main.Components.Elements.slides;
      const mainSlide = mainSlides.find(slide => slide.getAttribute('data-media-id') === mediaId.toString());

      if (mainSlide) {
        const mainIndex = mainSlides.indexOf(mainSlide);
        if (mainIndex !== -1) {
          this.main.go(mainIndex);
        }
      }
      
      if( this.hasAttribute('desktop-grid') && window.innerWidth >= 768){
        const galleryListsContainer = this.querySelector('.splide__gallery'); 
        if (galleryListsContainer) {
          const galleryLists = galleryListsContainer.querySelectorAll('.splide__slide');
          galleryLists.forEach(item => {
            if (item.getAttribute('data-media-id') === mediaId.toString()) {
              
              const headerOffset = document.querySelector('.header').offsetHeight + 16;
              const elementPosition = item.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - headerOffset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          });
        }
      } 
    }

    updateThumbnailARIA() {
      if (!this.thumbnails || !this.thumbnails.Components || !this.thumbnails.Components.Elements.list) return;
      const thumbnailItems = this.thumbnails.Components.Elements.list.querySelectorAll('.splide__slide');
      thumbnailItems.forEach((thumbnailItem) => {
        thumbnailItem.setAttribute('role', 'tab');
      });
    }

    filterSlides(group) {
      const normalizedGroup = String(group || '').trim();
      const mediaGroup = this.mediaGroups.get(normalizedGroup);
      const selectedGroup = mediaGroup?.slides.length && mediaGroup?.thumbnails.length ? normalizedGroup : '';
      if (selectedGroup === this.activeMediaGroup) return;
      const mainList = this.main.Components.Elements.list;
      const thumbList = this.thumbnails.Components.Elements.list;
    
      if (!mainList || !thumbList) {
        console.error('Splide list element not found for main or thumbnails.');
        return;
      }
    
      const slidesToShow = selectedGroup ? mediaGroup.slides : this.originalSlides;
      const thumbsToShow = selectedGroup ? mediaGroup.thumbnails : this.originalThumbnails;
      mainList.replaceChildren(...slidesToShow);
      thumbList.replaceChildren(...thumbsToShow);
      this.activeMediaGroup = selectedGroup;
    
      try {
          this.main.refresh();
          this.thumbnails.refresh();
    
          if (slidesToShow.length > 0) {
              this.main.go(0);
              this.thumbnails.go(0);
              this.updateSlideCounter(0); 
          } else {
              this.updateSlideCounter(-1); 
              console.warn("No slides to display in the carousel after filtering.");
          }
      } catch (error) {
          console.error("Error refreshing Splide instances:", error);
      }
    
      slidesToShow.forEach((slide) => slide.querySelectorAll('responsive-image').forEach(img => {
        if (typeof img.activateSizing === 'function') {
          img.activateSizing();
        }
      }));
    
      // Update ARIA attributes for accessibility on the thumbnails
      this.updateThumbnailARIA();
    }
    
  }
  
  customElements.define('gallery-carousel', GalleryCarousel);
}


/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = null;
    }

    connectedCallback() {
      this.dataset.url ? this.observeWhenVisible() : console.error('No data-url attribute found.');
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      this.requestController?.abort();
    }

    observeWhenVisible() {
      if (!('IntersectionObserver' in window)) {
        this.fetchProducts();
        return;
      }

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry || !entry.isIntersecting) return;

          this.intersectionObserver.disconnect();
          this.intersectionObserver = null;
          this.fetchProducts();
        },
        {
          rootMargin: '300px 0px',
        }
      );

      this.intersectionObserver.observe(this);
    }

    async fetchProducts() {
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      try {
        const response = await fetch(this.dataset.url, { signal: controller.signal });
        if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('product-recommendations');
        
        if (!this.isConnected || controller !== this.requestController) return;
        if (recommendations && recommendations.innerHTML.trim()) {
          this.renderRecommendations(recommendations.innerHTML);
        } else {
          this.classList.add('related-products--empty');
        }

      } catch (error) {
        if (error.name !== 'AbortError') {
          this.classList.add('related-products--empty');
          console.error('Error fetching product recommendations:', error);
        }
      } finally {
        if (this.requestController === controller) this.requestController = null;
      }
    }

    renderRecommendations(html) {
      this.innerHTML = html;
      this.classList.add('product-recommendations--loaded');
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}



class ComponentDrawer extends HTMLElement {
  constructor() {
    super();

    this.triggerButton = null;
    this.handleOverlayClick = this.close.bind(this);
    this.handleCloseClick = this.close.bind(this);
    this.refreshElements();

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
  }

  refreshElements() {
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.handleOverlayClick);
    }

    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleCloseClick);
    }

    this.overlay = this.querySelector('.drawer-overlay');
    this.drawer = this.querySelector('.drawer-content');
    this.closeButton = this.querySelector('.close-drawer-btn');

    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleOverlayClick);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleCloseClick);
    }
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'dialog');
    }
    document.addEventListener('keydown', this.handleKeyPress);
  }
  
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('focus', this.trapFocus, true);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer?.setAttribute('aria-hidden', 'false');
    this.closeButton?.focus();
    document.addEventListener('focus', this.trapFocus, true);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.drawer?.setAttribute('aria-hidden', 'true');
    document.removeEventListener('focus', this.trapFocus, true);
  
    if (this.triggerButton) {
      this.triggerButton.focus();
      this.triggerButton = null;
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  trapFocus(event) {
    if (!this.contains(event.target)) {
      event.stopPropagation();
      this.closeButton?.focus();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }
}

customElements.define('component-drawer', ComponentDrawer);

class SearchDrawer extends ComponentDrawer {
  constructor() {
    super();
    this.predictiveSearch = this.querySelector('predictive-search');
    this.openTransitionEndHandler = this.openTransitionEndHandler.bind(this);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.addEventListener('transitionend', this.openTransitionEndHandler);
    document.addEventListener('focus', this.trapFocus, true);
  }

  openTransitionEndHandler(event) {
    if (event.target === this.overlay) {
      this.removeEventListener('transitionend', this.openTransitionEndHandler);

      if (this.predictiveSearch) {
        setTimeout(() => {
          const focusElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
          if (focusElement && typeof focusElement.focus === 'function') {
            focusElement.focus();
          }
        }, 150);
      }
    }
  }

  close() {
    if (this.predictiveSearch) {
      const inputElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
      if (inputElement) {
        inputElement.value = '';
      }
      if (this.predictiveSearch.hasAttribute('open')) {
        this.predictiveSearch.removeAttribute('open');
      }
      this.predictiveSearch.setAttribute('results', 'false');
    }

    super.close();
  }
}


customElements.define('search-drawer', SearchDrawer);

class DrawerButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  connectedCallback() {
    this.targetId = this.getAttribute('data-target');
    this.targetDrawer = document.getElementById(this.targetId);
    
    this.setAttribute('tabindex', '0');
    this.setAttribute('role', 'button');
    
    if (this.targetDrawer) {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeyPress);
    } else {
      console.warn(`Drawer element with ID '${this.targetId}' does not exist.`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  }

  handleClick() {
    if (this.targetDrawer && typeof this.targetDrawer.open === 'function') {
      this.targetDrawer.open(this); 
    }
  }
}

customElements.define('drawer-button', DrawerButton);

/**
 *  @class
 *  @function QuickView
 */

/**
 *  @class
 *  @function CollapsibleDetails
 */

if (!customElements.get('collapsible-details')) {
  class CollapsibleDetails extends HTMLElement {
    constructor() {
      super();
      this.toggleContent = this.toggleContent.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.updateHeight = this.updateHeight.bind(this);
      this.setResponsiveState = this.setResponsiveState.bind(this);
      this.isAnimating = false;
    }

    connectedCallback() {
      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.querySelector('summary');
      this.contentEl = this.querySelector('.collapsible__content');
      this.contentInnerEl = this.querySelector('.collapsible__content-inner');
    
      if (!this.detailsEl || !this.summaryEl || !this.contentEl) {
        return;
      }
    
      this.wrapContent();
      this.setupInitialState();
      this.addEventListeners();
    
      // Setup ResizeObserver to handle content size changes
      if (this.contentInnerEl) {
        this.resizeObserver = new ResizeObserver(this.updateHeight);
        this.resizeObserver.observe(this.contentInnerEl);
      }
    
      if (this.detailsEl.dataset.responsive === 'true') {
        this.setResponsiveState();
      }
    
      this.mutationObserver = new MutationObserver(this.updateContentHeight.bind(this));
      if (this.contentInnerEl) {
        this.mutationObserver.observe(this.contentInnerEl, { 
          childList: true, 
          subtree: true, 
          characterData: true 
        });
      }
    }


    wrapContent() {
      if (!this.contentEl || !this.contentEl.parentElement) {
        return;
      }
    
      if (this.contentEl.parentElement.classList.contains('collapsible__content-wrapper')) {
        this.contentWrapper = this.contentEl.parentElement;
        return;
      }
    
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible__content-wrapper';
    
      this.contentEl.parentNode.insertBefore(this.contentWrapper, this.contentEl);
      this.contentWrapper.appendChild(this.contentEl);
    }
    

    setupInitialState() {
      if (!this.detailsEl) {
        return;
      }
    
      if (this.detailsEl.hasAttribute('open')) {
        this.contentWrapper.style.height = 'auto';
        this.contentEl.style.transform = 'translateY(0)';
        this.detailsEl.classList.add('is-open');
      } else {
        this.contentWrapper.style.height = '0';
        this.contentEl.style.transform = 'translateY(16px)';
      }
    }


    addEventListeners() {
      if (!this.summaryEl || !this.contentWrapper) {
        return;
      }
    
      this.summaryEl.addEventListener('click', this.toggleContent);
      this.contentWrapper.addEventListener('transitionend', this.onTransitionEnd);
    }

    toggleContent(event) {
      event.preventDefault();
      if (this.isAnimating) {
        this.pendingState = !this.detailsEl.open;
        return;
      }
      
      this[this.detailsEl.open ? 'closeContent' : 'openContent']();
    }

    openContent() {
      this.isAnimating = true;
      this.detailsEl.open = true;
      
      requestAnimationFrame(() => {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = '0';
        this.contentEl.style.transform = 'translateY(16px)';
        
        requestAnimationFrame(() => {
          this.detailsEl.classList.add('is-open');
          this.contentWrapper.style.height = `${height}px`;
          this.contentEl.style.transform = 'translateY(0)';
        });
      });
    }

    closeContent() {
      this.isAnimating = true;
      
      requestAnimationFrame(() => {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
        
        requestAnimationFrame(() => {
          this.detailsEl.classList.remove('is-open');
          this.contentWrapper.style.height = '0';
          this.contentEl.style.transform = 'translateY(16px)';
        });
      });
    }

    onTransitionEnd(event) {
      if (event.propertyName !== 'height' || event.target !== this.contentWrapper) return;
      
      this.isAnimating = false;
      
      if (!this.detailsEl.classList.contains('is-open')) {
        this.detailsEl.open = false;
      } else {
        this.contentWrapper.style.height = 'auto';
      }

      if (this.pendingState !== undefined) {
        this[this.pendingState ? 'openContent' : 'closeContent']();
        this.pendingState = undefined;
      }
    }

    updateHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        this.contentWrapper.style.height = 'auto';
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }
    updateContentHeight() {
      if (this.detailsEl.open) {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    disconnectedCallback() {
      if (this.summaryEl) {
        this.summaryEl.removeEventListener('click', this.toggleContent);
      }
    
      if (this.contentWrapper) {
        this.contentWrapper.removeEventListener('transitionend', this.onTransitionEnd);
      }
    
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
    setResponsiveState() {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
      if (isMobile && this.detailsEl.open) {
        return;
      }
    
      this.detailsEl.open = !isMobile;
      this.detailsEl.classList.toggle('is-open', !isMobile);
    
      if (isMobile) {
        this.contentWrapper.style.height = '0';
      } else {
        this.contentWrapper.style.height = 'auto';
        this.contentEl.style.transform = 'translateY(0)';
        
        setTimeout(() => {
          const height = this.contentEl.scrollHeight;
          this.contentWrapper.style.height = `${height}px`;
        }, 0);
      }
    }
    
    
  }

  customElements.define('collapsible-details', CollapsibleDetails);
}

// Use a debounced resize handler for better performance
function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

window.addEventListener('resize', debounce(() => {
  document.querySelectorAll('collapsible-details details[data-responsive="true"]')
    .forEach(details => details.closest('collapsible-details').setResponsiveState());
}));

/**
 *  @class
 *  @function TabsComponent
 */

if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.pendingTabLoads = new Map();
    }

    connectedCallback() {
      this.tabsHeader = this.querySelector('.tabs-header');
      this.tabsContent = this.querySelector('.tabs-content');
      this.tabActiveIndicator = this.querySelector('.indicator');

      this.tabsHeader.addEventListener('click', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.activateTab(e.target);
        }
      });

      this.tabsHeader.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.handleKeyDown(e);
        }
      });

      this.activateTab(this.tabsHeader.querySelector('.tab-button'));

      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      }
    }

    activateTab(tab) {
      const tabIndex = tab.getAttribute('data-tab');
      let activeContent;

      this.tabsHeader.querySelectorAll('.tab-button').forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive);
        t.setAttribute('tabindex', isActive ? '0' : '-1'); 
      });

      this.tabsContent.querySelectorAll('.tab-content').forEach((content) => {
        const isActive = content.getAttribute('id') === tabIndex;
        content.classList.toggle('active', isActive);

        if (isActive) {
          activeContent = content;
        }
      });

      this.loadDeferredTabContent(activeContent);

      const tabRect = tab.getBoundingClientRect();
      const tabsHeaderRect = this.tabsHeader.getBoundingClientRect();
      const offsetLeft = tabRect.left - tabsHeaderRect.left;

      this.tabsHeader.style.setProperty('--indicator-width', `${tabRect.width}px`);
      this.tabsHeader.style.setProperty('--indicator-offset', `${offsetLeft}px`);
    }

    loadDeferredTabContent(tabContent) {
      if (!tabContent || !tabContent.hasAttribute('data-tab-deferred')) return Promise.resolve();
      if (tabContent.getAttribute('data-tab-loaded') === 'true') return Promise.resolve();

      const existingRequest = this.pendingTabLoads.get(tabContent.id);
      if (existingRequest) return existingRequest;

      const requestUrl = this.buildDeferredTabUrl(tabContent);
      if (!requestUrl) return Promise.resolve();

      this.renderDeferredTabState(tabContent, 'loading');

      const loadRequest = fetch(requestUrl, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to load tab panel: ${response.status}`);
          }

          return response.text();
        })
        .then((responseText) => {
          const parsedDocument = new DOMParser().parseFromString(responseText, 'text/html');
          const sectionRoot = parsedDocument.querySelector('.shopify-section');
          const html = (sectionRoot ? sectionRoot.innerHTML : responseText).trim();

          if (!html) {
            throw new Error('Received empty tab panel response');
          }

          tabContent.innerHTML = html;
          tabContent.removeAttribute('data-tab-deferred');
          tabContent.setAttribute('data-tab-loaded', 'true');
          tabContent.removeAttribute('aria-busy');
          tabContent.removeAttribute('data-tab-state');

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(tabContent);
          }

          tabContent.querySelectorAll('splide-carousel').forEach((carousel) => {
            if (typeof carousel.mountSplideWhenNeeded === 'function') {
              carousel.mountSplideWhenNeeded();
            }
          });
        })
        .catch((error) => {
          console.error('Failed to load deferred collection tab content:', error);
          this.renderDeferredTabState(tabContent, 'error');
          tabContent.setAttribute('data-tab-loaded', 'false');
        })
        .finally(() => {
          this.pendingTabLoads.delete(tabContent.id);
        });

      this.pendingTabLoads.set(tabContent.id, loadRequest);
      return loadRequest;
    }

    buildDeferredTabUrl(tabContent) {
      const sectionId = tabContent.getAttribute('data-tab-section-id');
      const blockId = tabContent.getAttribute('data-tab-block-id');

      if (!sectionId || !blockId) return null;

      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('collection_tabs_partial', '1');
      url.searchParams.set('collection_tab_block', blockId);

      return url.toString();
    }

    renderDeferredTabState(tabContent, state) {
      tabContent.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      tabContent.setAttribute('data-tab-state', state);

      if (state === 'loading') {
        tabContent.innerHTML = `
          <div class="collection-tabs__panel-state" role="status" aria-live="polite">
            Loading products...
          </div>
        `;
        return;
      }

      if (state === 'error') {
        tabContent.innerHTML = `
          <div class="collection-tabs__panel-state collection-tabs__panel-state--error" role="status" aria-live="polite">
            Failed to load products. Please try again.
          </div>
        `;
      }
    }

    handleKeyDown(e) {
      const key = e.key;
      const currentTab = e.target;
      let newTab;

      switch (key) {
        case 'ArrowRight':
          newTab = currentTab.nextElementSibling || this.tabsHeader.firstElementChild;
          break;
        case 'ArrowLeft':
          newTab = currentTab.previousElementSibling || this.tabsHeader.lastElementChild;
          break;
        case 'Enter':
        case 'Space':  
          this.activateTab(currentTab);
          return;
      }

      if (newTab && newTab.classList.contains('tab-button')) {
        e.preventDefault();
        newTab.focus(); 
      }
    }

    handleBlockSelect(e) {
      const blockId = e.detail.blockId;
      const tabToActivate = this.tabsHeader.querySelector(`[data-tab="tab-${blockId}"]`);
      if (tabToActivate) {
        this.activateTab(tabToActivate);
      }
    }
  }

  customElements.define('tabs-component', TabsComponent);
}

/**
 *  @class
 *  @function CountdownTimer
 */

if (!customElements.get('count-down')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endTime = new Date(this.getAttribute('data-timer')).getTime();
      this.daysElem = this.querySelector('li[data-value="days"] .countdown-day');
      this.hoursElem = this.querySelector('li[data-value="hours"] .countdown-hour');
      this.minutesElem = this.querySelector('li[data-value="minutes"] .countdown-minute');
      this.secondsElem = this.querySelector('li[data-value="seconds"] .countdown-second');
      this.onVisibilityChange = this.startCountdown.bind(this);
    }

    connectedCallback() {
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.startCountdown();
    }

    disconnectedCallback() {
      clearTimeout(this.countdownTimer);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    startCountdown() {
      clearTimeout(this.countdownTimer);
      if (!this.isConnected || document.hidden) return;
      const distance = this.endTime - Date.now();
      if (!Number.isFinite(distance) || distance <= 0) {
        this.displayTime(0, 0, 0, 0);
        return;
      }
      this.displayTime(
        Math.floor(distance / 86400000),
        Math.floor(distance % 86400000 / 3600000),
        Math.floor(distance % 3600000 / 60000),
        Math.floor(distance % 60000 / 1000)
      );
      this.countdownTimer = setTimeout(() => this.startCountdown(), distance % 1000 + 1);
    }

    displayTime(days, hours, minutes, seconds) {
      for (const [element, value] of [[this.daysElem, days], [this.hoursElem, hours], [this.minutesElem, minutes], [this.secondsElem, seconds]]) {
        if (element && element.textContent !== String(value)) element.textContent = String(value);
      }
    }
  }

  customElements.define('count-down', CountdownTimer);
}

(function() {
  function getAbsoluteTop(element) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(event) {
      if (event.target.matches('[data-anchor]')) {
        event.preventDefault();
        
        const href = event.target.getAttribute('href');
        if (!href || href === '#') return;
        
        const targetId = href.replace('#', '');
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const targetPosition = getAbsoluteTop(targetSection) - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  }

  // Init when DOM is ready
  document.addEventListener('DOMContentLoaded', initSmoothScroll);
})();

if (!customElements.get('show-more-toggle')) {
  customElements.define(
    'show-more-toggle',
    class ShowMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-show-more-content]');
        this.button = this.querySelector('button');
        this.showMoreText = this.querySelector('.label-show-more');
        this.showLessText = this.querySelector('.label-show-less');
        this.collectionHero = this.closest('.collection-hero--with-image');
        this.handleResize = this.updateCollectionHeroLayout.bind(this);

        if (this.collectionHero) {
          this.collectionHeroInner = this.closest('.collection-hero__inner');
          this.collectionHeroContent = this.closest('.collection-hero__content');
          this.collectionHeroImageContainer = this.collectionHero.querySelector('.collection-hero__image-container');
          this.collectionHeroImage = this.collectionHero.querySelector('.collection-hero__image');
        }

        this.button.addEventListener('click', () => this.toggle());
      }

      connectedCallback() {
        if (this.collectionHero) {
          window.addEventListener('resize', this.handleResize);
        }
      }

      disconnectedCallback() {
        if (this.collectionHero) {
          window.removeEventListener('resize', this.handleResize);
        }
      }

      updateCollectionHeroLayout() {
        if (
          !this.collectionHero ||
          !this.collectionHeroInner ||
          !this.collectionHeroContent ||
          !this.collectionHeroImageContainer ||
          !this.collectionHeroImage
        ) {
          return;
        }

        const isExpanded = !this.content.classList.contains('content-truncated');

        if (!isExpanded) {
          this.collectionHero.classList.remove('collection-hero--expanded');
          this.collectionHeroImageContainer.style.removeProperty('min-height');
          this.collectionHeroImage.style.removeProperty('min-height');
          return;
        }

        const innerStyles = window.getComputedStyle(this.collectionHeroInner);
        const paddingTop = parseFloat(innerStyles.paddingTop) || 0;
        const paddingBottom = parseFloat(innerStyles.paddingBottom) || 0;
        const requiredHeight = Math.ceil(this.collectionHeroContent.scrollHeight + paddingTop + paddingBottom);

        this.collectionHero.classList.add('collection-hero--expanded');
        this.collectionHeroImageContainer.style.minHeight = `${requiredHeight}px`;
        this.collectionHeroImage.style.minHeight = `${requiredHeight}px`;
      }

      toggle() {
        this.content.classList.toggle('content-truncated');
        this.showMoreText.classList.toggle('hidden');
        this.showLessText.classList.toggle('hidden');

        if (this.collectionHero) {
          requestAnimationFrame(() => this.updateCollectionHeroLayout());
        }
      }
    }
  );
}
